/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';
import type { ProjectDescription } from './';
import {
    ProjectDescriptionFromJSON,
    ProjectDescriptionFromJSONTyped,
    ProjectDescriptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface AddFreelancersToExistingBriefRequest
 */
export interface AddFreelancersToExistingBriefRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddFreelancersToExistingBriefRequest
     */
    profileIds: Array<string>;
    /**
     * 
     * @type {Origin}
     * @memberof AddFreelancersToExistingBriefRequest
     */
    origin: Origin;
    /**
     * 
     * @type {string}
     * @memberof AddFreelancersToExistingBriefRequest
     */
    searchId?: string;
    /**
     * 
     * @type {string}
     * @memberof AddFreelancersToExistingBriefRequest
     */
    profileViewId?: string;
    /**
     * 
     * @type {ProjectDescription}
     * @memberof AddFreelancersToExistingBriefRequest
     */
    description?: ProjectDescription;
}

/**
 * Check if a given object implements the AddFreelancersToExistingBriefRequest interface.
 */
export function instanceOfAddFreelancersToExistingBriefRequest(value: object): value is AddFreelancersToExistingBriefRequest {
    if (!('profileIds' in value) || value['profileIds'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function AddFreelancersToExistingBriefRequestFromJSON(json: any): AddFreelancersToExistingBriefRequest {
    return AddFreelancersToExistingBriefRequestFromJSONTyped(json, false);
}

export function AddFreelancersToExistingBriefRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFreelancersToExistingBriefRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'profileIds': json['profileIds'],
        'origin': OriginFromJSON(json['origin']),
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'profileViewId': json['profileViewId'] == null ? undefined : json['profileViewId'],
        'description': json['description'] == null ? undefined : ProjectDescriptionFromJSON(json['description']),
    };
}

export function AddFreelancersToExistingBriefRequestToJSON(value?: AddFreelancersToExistingBriefRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileIds': value['profileIds'],
        'origin': OriginToJSON(value['origin']),
        'searchId': value['searchId'],
        'profileViewId': value['profileViewId'],
        'description': ProjectDescriptionToJSON(value['description']),
    };
}

